document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('[data-mokotracker-hero]');
  if (!hero) return;

  hero.addEventListener('click', () => {
    const productSection = document.getElementById('product-wrapper');
    productSection?.scrollIntoView({ behavior: 'smooth' });
  });
});
